import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { useApp } from '@wap-client/core'
import Anchor from '@/components/base/anchor'
import { Column, Row, Container } from '@/components/base/gridview'
import Icon from '@/components/base/icon'
import Image from '@/components/base/image'

import { PanelProps } from './types'

const Panel: React.FunctionComponent<PanelProps> = ({
  children,
  isOpen,
  logo,
  onClose,
}) => {
  const app = useApp()
  const router = useRouter()

  if (!isOpen) return null

  return (
    <div className={`panel panel--${isOpen ? 'show' : 'hide'}`}>
      <div className="panel__header">
        <Container size="extended">
          <Row xs={{ justify: 'between', align: 'center' }}>
            <Column xs={{ auto: true }}>
              <div className="panel__header__logo">
                <Anchor href={app.settings.homepage || '/'}>
                  <Image {...logo} alt="" />
                </Anchor>
              </div>
            </Column>
            <Column xs={{ auto: true }}>
              <button className="panel__close-button" onClick={onClose}>
                <Icon name="close" />
              </button>
            </Column>
          </Row>
        </Container>
      </div>
      <div className="panel__content">{children}</div>
    </div>
  )
}

export default Panel
